/* eslint-disable import/first */
import React, { useEffect } from "react";
import { IECFilterType } from "../../../models/IECActivitiesModel";
import { IecActivitiesFilter } from "./IECActivityFilters";
import { IECActivitiesFormDetails } from "./IECActivityFormDetails";
import Label from "../../../components/Label";
import "./IECStyles.css";
import StickyIECHeadTable from "./IECTableComponent";
import { useDispatch, useSelector } from "react-redux";
import { getExcelDownload, getIECInfoData, getSeasonsDataAPICall } from "../../../api/iecAcitivityAPI";;
import IECPagination from "../../../components/IECPagination";
import { handleIECPaginationDataSlice, handleUpdatePageSlice } from "../../../redux/slices/globalSlice";
import { handleFetchExcelData, handleFetchIecFormData} from "../../../redux/slices/iecActivitySlice";
import { IconButton } from "@mui/material";
import BackArrow from "../../../assets/img/back-arrow.svg";
import { ImageDownloadTable } from "./IECImageSection";
import { Button } from "reactstrap";
import DownloadIcon from "../../../assets/img/download.svg";

/**Component is used to deal with IEC Activities*/
const IECActivities = () => {
  const dispatch: any = useDispatch();
  const { 
    storeIecFormData = {}, 
    storeExcelData = {}, 
    storeSavedFilterValues = {}, 
    storeIecInfoData = {}, 
    storeImageData = {} 
  } = useSelector((state: any) => state.iecActivity || {});
  const { 
    updatePageStore = false, 
    storeIECPaginationData = {} 
  } = useSelector((state: any) => state.global || {});

  useEffect(() => {
    if (storeExcelData.statusCode === 1 && storeExcelData.data) {
      const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${storeExcelData.data}`;
      const downloadLink = document.createElement('a');
      const fileName = `${Date.now()}.xlsx`;
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      dispatch(handleFetchExcelData({}))
    }

  }, [storeExcelData?.statusCode === 1])

  const downloadExcelWithFilters = () => {
    dispatch(getExcelDownload({seasonId: storeSavedFilterValues.seasonId, stateId: storeSavedFilterValues.stateId, districtId: storeSavedFilterValues.districtId, blockId: storeSavedFilterValues.blockId, activityId: storeSavedFilterValues.activityId, fromDate: storeSavedFilterValues.fromDate, toDate: storeSavedFilterValues.toDate, year: storeSavedFilterValues.year, mobileNumber: storeSavedFilterValues.mobileNumber }));
  }

  /** Method to change pagination limit */
  const changePaginationLimit = (value: number) => {
    dispatch(
      handleIECPaginationDataSlice({
        ...storeIECPaginationData,
        offset: 0,
        limit: value,
        selectedLimit: value,
      })
    );
  };

  /** Method to go to previous page */
  const prevPage = (value: number) => {
    if (
      value >= storeIECPaginationData.selectedLimit &&
      storeIECPaginationData.offset > 0
    ) {
      dispatch(
        handleIECPaginationDataSlice({
          ...storeIECPaginationData,
          limit:
            storeIECPaginationData.limit -
              storeIECPaginationData.selectedLimit <
              25
              ? storeIECPaginationData.selectedLimit
              : storeIECPaginationData.limit -
              storeIECPaginationData.selectedLimit,
          offset:
            storeIECPaginationData.offset -
            storeIECPaginationData.selectedLimit,
        })
      );
    }
  };

  /** Method to go to next page */
  const nextPage = (value: number) => {
    if (value < storeIecInfoData?.count) {
      dispatch(
        handleIECPaginationDataSlice({
          ...storeIECPaginationData,
          offset: storeIECPaginationData.limit,
          limit: value + storeIECPaginationData.selectedLimit,
        })
      );
    }
  };

  const handleBack = () => {
    dispatch(handleUpdatePageSlice(false));
    dispatch(handleFetchIecFormData({}))
  }

  return (
    <>
      {!updatePageStore ? (
        <>
          <IecActivitiesFilter onApplyFilters={function (iecFilterType: IECFilterType): void {
            throw new Error("Function not implemented.");
          }} />
          <div className="buttons-container">
            <p style={{ fontSize: "12px", color: "#5C79AA", fontWeight: 600 }}>
              Total Records {storeIecInfoData?.count === undefined ? 0 : `${(storeIECPaginationData.limit > storeIecInfoData?.count) ? storeIecInfoData?.count : storeIECPaginationData.limit}/${storeIecInfoData?.count}`} 
            </p>
            <Button
              variant="outline-primary"
              className="mb-2 cl-btn-outline-primary fs-small"
              onClick={() => downloadExcelWithFilters()}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
                Export XLS
              <img
                src={DownloadIcon}
                alt="Download"
                style={{
                  width: '16px',
                  height: '16px',
                  filter: 'brightness(0) saturate(100%) invert(31%) sepia(15%) saturate(1234%) hue-rotate(189deg) brightness(95%) contrast(89%)',
                  transition: 'filter 0.2s ease'
                }}
              />
            </Button>
          </div>
          <StickyIECHeadTable />
          <IECPagination storeIecInfoData={storeIecInfoData} storeIECPaginationData={storeIECPaginationData}
            changePaginationLimit={changePaginationLimit}
            nextPage={nextPage}
            prevPage={prevPage} />
        </>
      ) :
        <>
          {storeIecFormData &&
            <div>
              <div className="d-flex justify-space-between align-items-center mb-3 w-100 px-0">
                <IconButton onClick={() => handleBack()}>
                  <img src={BackArrow} className="back-arrow-icon" />
                </IconButton>
                <span className="fw-bold kml-id-text">IEC ID - {storeIecFormData?.data?.[0]?.iecId}</span>
              </div>
              <div className="iec-form-layout">
                <IECActivitiesFormDetails />
                <ImageDownloadTable storeIecFormData={storeIecFormData} />
              </div>
            </div>
          }
        </>
      }
    </>
  );
};

export default IECActivities;
